import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import "./LeaveApply.css";
import { useDispatch, useSelector } from "react-redux";
import { addLeaveBalance, getLeaveBalanceList, getLeaveTypeList } from "../../Redux/Leave/Action";
import { empList } from "../../Redux/DailyUpdateApproval/Action";
import { FaMinus, FaPlus } from "react-icons/fa6";
import Swal from "sweetalert2";
import Select from "react-select";
import NewDataTable from "../DataTable/NewDataTable";

const LeaveBalance = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const { allleavebalancelist, leavetypelist } = useSelector((store) => store.leave);
  const { emplists } = useSelector((store) => store.dailyUpdateApprover);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([{ leaveCode: "", leaveDays: "" }]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);


  useEffect(() => {
    dispatch(empList(token, "EMP_SUPPORT"));
    dispatch(getLeaveTypeList(token));
    if (selectedEmployee && selectedEmployee !== null) {
      dispatch(getLeaveBalanceList(token, selectedEmployee?.value, 'Balance'));
    }
  }, [dispatch, token, selectedEmployee]);


  const options = emplists.map((emp) => ({
    value: emp.loginId,
    label: `${emp?.firstName || ""} ${emp?.lastName || ""}`.trim(),
  }));

  useEffect(() => {
    if (options.length > 0 && selectedEmployee === null) {
      setSelectedEmployee(options[0]);
    }
  }, [options, selectedEmployee]);

  const handleEmpChange = (selectedOption) => {
    setSelectedEmployee(selectedOption);
  };

  const handleShow = () => {
    setRows([{ leaveCode: "", leaveDays: "" }]);
    setShow(true);
  };

  const handleClose = () => {
    setRows([{ leaveCode: "", leaveDays: "" }]);
    setShow(false);
  };

  const handleAddRow = () => {
    setRows([...rows, { leaveCode: "", leaveDays: "" }]);
  };

  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const transformedRows = rows.map(row => ({
      ...row,
      leaveDays: Number(row.leaveDays) || 0,
    }));

    const leaveData = {
      loginId: selectedEmployee?.value,
      leaveDetails: transformedRows,
      action: 'INSERT'
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Add it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(addLeaveBalance(token, leaveData))
          .then((response) => {
            if (response.statusMessage === "SUCCESS") {
              handleClose();
              dispatch(getLeaveBalanceList(token, selectedEmployee?.value, 'Balance'));
              Swal.fire({
                title: "Success!",
                text: response.statusDesc,
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: response.statusDesc,
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong during submission!",
            });
          });
      }
    });

  };


  const columns = [
    {
      name: "SN",
      cell: (_, index) => index + 1,
      sortable: false,
      width: "80px",
      align: "center",
    },

    {
      name: "Leave Code",
      selector: (row) => row?.leaveCode || "-",
      sortable: true,
      align: "center",
    },
    {
      name: "Leave Description",
      selector: (row) => {
        const match = leavetypelist.find((leave) => leave.leaveCode === row.leaveCode);
        return match?.leaveDesc || "-";
      },
      sortable: true,
      align: "center",
    },
    {
      name: "No of Days",
      selector: (row) => row?.leaveDays ?? "-",
      sortable: true,
      align: "center",
    },
  ];


  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        <div className="container-fluid mt-4">
          <div className="row mb-3 justify-content-end align-items-center">
            <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
              <b>
                <label className="custom-label">Employee :</label>
              </b>
            </div>
            <div className="col-sm-4">
              <Select
                options={options}
                value={selectedEmployee}
                onChange={handleEmpChange}
                placeholder="Select Employee"
                isClearable
              />
            </div>
            <div className="col-auto d-flex align-items-center">
              <button className="btn btn-primary" onClick={handleShow}>
                ADD LEAVE BALANCE
              </button>
            </div>
          </div>
          <div className="card3">
            <div className="card-body">
              <NewDataTable
                columns={columns}
                data={allleavebalancelist || []}
                tableName="LEAVE BALANCE"
                totalRecord={allleavebalancelist?.length}
              />
            </div>
          </div>
        </div>
      </div>
      {show && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal fade leave-modal show"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div
              className="modal-dialog modal-lg modal-dialog"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    ADD LEAVE BALANCE
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {rows.map((row, index) => (
                        <div className="row align-items-center mt-3" key={index}>
                          {/* Leave Type Dropdown */}
                          <div className="col-md-6">
                            <label htmlFor="leaveCode" className="form-label">
                              Leave Type <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              value={row.leaveCode}
                              onChange={(e) =>
                                handleRowChange(index, "leaveCode", e.target.value)
                              }
                              required
                            >
                              <option value="" disabled>
                                Select Leave Type
                              </option>
                              {leavetypelist
                                .filter(
                                  (leave) =>
                                  (leave.leaveCode === "CL" ||
                                    leave.leaveCode === row.leaveCode
                                  ))
                                .map((leave, i) => (
                                  <option key={i} value={leave.leaveCode}>
                                    {`${leave.leaveDesc} (${leave.leaveCode})`}
                                  </option>
                                ))}
                            </select>
                          </div>

                          {/* Leave Days Input */}
                          <div className="col-md-4">
                            <label htmlFor="leaveDays" className="form-label">
                              Leave Days <span className="text-danger">*</span>
                            </label>
                            <input
                              type="number"
                              step="1"         
                              min="0"
                              className="form-control"
                              placeholder="Enter Leave Days"
                              value={row.leaveDays}
                              onChange={(e) =>
                                handleRowChange(index, "leaveDays", e.target.value)
                              }
                              required
                            />
                          </div>
                          {/* Add Row Button */}
                          {/* <div className="col-md-1 text-center" style={{ marginTop: '29px' }}>
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={handleAddRow}
                            >
                              <FaPlus />
                            </button>
                          </div> */}

                          {/* Remove Row Button */}
                          <div className="col-md-1 text-center" style={{ marginTop: '29px' }}>
                            {index > 0 && (
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => handleRemoveRow(index)}
                              >
                                <FaMinus />
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                      <div className="row">
                        <div className="col text-center mt-3">
                          <button
                            type="submit"
                            id="sbmtdata"
                            className="btn btn-success"
                          >
                            SUBMIT
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

    </div>
  );
};

export default LeaveBalance;